import { collection, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";

const Testimonies = () => {
    const [data, setData] = useState([]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "Testimonies"));
                const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                const querySnapshot2 = await getDocs(collection(db, "Members"));
                const documents2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                for (let i = 0; i < documents2.length; i++) {
                    for (let j = 0; j < documents.length; j++) {
                      if (documents[j].Member === documents2[i].id) {
                        documents[j].Name = documents2[i].Name;
                        documents[j].Image = documents2[i].ProfileImage;
                      }
                    }
                }
                  

                console.log(documents)
                setData(documents);
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };
    
        fetchData();
    }, []);

    return (
        <div id="content">
            <div className='row'>
                <h1>Testimony Board</h1>
                <h2 className='ev-sub-title'>Revival Church Montana</h2>
            </div>
            <div className='row'>
                {data.map(item => {
                    return (<div className="col-sm-4 member-box" style={{display: 'flex', flexDirection: 'column',alignItems: 'center',justifyContent: 'flex-start',padding: '35px',textAlign: 'center'}}>
                        <img src={item.Image} style={{width: "70px", borderRadius: "500px"}}/>
                        <br/>
                        <h4>{item.Name}</h4>
                        <br/>
                        <p>{item.Testimony}</p>
                    </div>)
                })}
            </div>
        </div>
    )
}

export default Testimonies; 